module.exports = __webpack_public_path__ + "img/clear.6fedf133.svg";